import axios from 'axios';

// API 기본 URL 설정
const baseURL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

console.log('API URL:', process.env.REACT_APP_API_URL);
console.log('Using API URL:', baseURL);

// Axios 인스턴스 생성
const instance = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// 요청 인터셉터 - 토큰이 있으면 헤더에 추가
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['x-auth-token'] = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 응답 인터셉터 - 401 에러 처리 (인증 만료)
instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      // 토큰 만료 또는 인증 오류
      localStorage.removeItem('token');
      localStorage.removeItem('userId');
      // 필요시 로그인 페이지로 리다이렉트
      // window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default instance; 